import { ManyPetsMigrationPageBlock } from './ManyPetsMigrationPageBlock'

export const manyPetsBlocks = [ManyPetsMigrationPageBlock]
